<template>
  <!-- 优惠券选择器 -->
  <el-dialog
    :visible.sync="dialogDiscounta"
    title="优惠券选择器"
    center
    width="1624px"
    :show-close="false"
    :close-on-click-modal="false"
    @open="getDiscountD"
  >
    <!-- <template slot="header"> -->
    <el-input
      @keyup.enter.native="getSearcs"
      style="width: 200px;margin-right: 20px;"
      class="filter-item"
      placeholder="请输入优惠券标题"
      size="small"
      v-model="listDiscount.keyword"
    ></el-input>
    <el-button @click="getSearcs" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    <el-button @click="getReses" class="filter-item" icon="search" size="small">重置</el-button>
    <!-- </template> -->
    <el-table
      size="small"
      :data="listDis"
      ref="multipleTable"
      stripe
      border
      highlight-current-row
      :row-key="getRowKeys"
      @select="selectHandle"
      @select-all="selectAllHandle"
      style=" margin-top: 20px"
    >
      <el-table-column align="center" label width="180" type="selection"></el-table-column>
      <el-table-column align="center" label="id" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.id}}</span>
        </template>
      </el-table-column>
      <el-table-column width="160" align="center" label="名称">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" align="center" label="介绍">
        <template slot-scope="scope">
          <span>{{scope.row.introduce}}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" align="center" label="满减金额">
        <template slot-scope="scope">
          <span>{{scope.row.reduceCost}}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" align="center" label="起用金额">
        <template slot-scope="scope">
          <span>{{scope.row.leastCost}}</span>
        </template>
      </el-table-column>
      <el-table-column width="170" align="center" label="开始时间">
        <template slot-scope="scope">
          <span>{{scope.row.startTime}}</span>
        </template>
      </el-table-column>
      <el-table-column width="170" align="center" label="结束时间">
        <template slot-scope="scope">
          <span>{{scope.row.endTime}}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" align="center" label="使用类型">
        <template slot-scope="scope">
          <span>{{scope.row.type == 1 ? '全场赠券' : (scope.row.stat == 2) ? '会员赠券' : (scope.row.stat == 3) ? '购物赠券' : '注册赠券'}}</span>
        </template>
      </el-table-column>
      <el-table-column width="110" align="center" label="限额数量">
        <template slot-scope="scope">
          <span>{{scope.row.limitCount}}</span>
        </template>
      </el-table-column>
      <el-table-column width="110" align="center" label="状态">
        <template slot-scope="scope" style="color:red">
          <span
            :class="scope.row.stat == 0 ? 'blue' : (scope.row.stat == 1) ? 'green' : (scope.row.stat == 2) ? 'black' : 'red' "
          >{{scope.row.stat == 0 ? '编辑状态' : (scope.row.stat == 1) ? '已发布' : (scope.row.stat == 2) ? '可使用' : '已下架'}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <div style="display:flex;justify-content:space-between;align-items:center;">
        <div style="display: flex;width:200px;font-size:14px;align-items:center;">
          最多可选
          <div style="color:red;margin:0 15px">无限制</div>已选：
          <div style="color:red;margin-top:2px">{{multipleSelecdis.length}}</div>
        </div>
        <el-pagination
          @size-change="handleSizeChangs"
          @current-change="handleCurrentChangs"
          :current-page.sync="listDiscount.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listDiscount.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDis"
          style="width:500px"
        ></el-pagination>
        <div style="width:155px">
          <el-button @click="getRedis()">取 消</el-button>
          <el-button @click="getDatdis()" type="primary">确定</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { getArrList } from '@/api/demo/discount/index'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    couponList: {
      type: Array,
      default () {
        return []
      }
    },
    limit: {
      // 最大限制选择数量
      type: [Number, String],
      default: 0
    },
    top: {
      type: String,
      default: '3vh'
    },
    width: {
      type: String,
      default: '66%'
    },
    center: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    dialogDiscounta: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    comSelectSList: {
      // 回传给调用组件者
      get () {
        return this.couponList
      },
      set (list) {
        this.$emit('update:couponList', list)
      }
    }
  },
  data () {
    return {
      listDis: [], // 优惠券列表
      totalDis: 0, // 优惠券
      isFilter: false,
      listLoading: true, // 加载圈圈
      listDiscount: {
        // 优惠券
        currentPage: 1,
        pageSize: 20,
        keyword: ''
      },
      multipleSelecdis: [], // 指定优惠券
      selectcSpuIds: [] // 选中的spuIds,回显数据匹配
    }
  },
  watch: {
    visible (newValue) {
      if (newValue === true) {
        this.getDiscountList()
      }
    }
  },
  methods: {
    // 每页条数
    handleSizeChangs (val) {
      this.listDiscount.pageSize = val
      this.getDiscountList()
    },
    // 当前页
    handleCurrentChangs (val) {
      this.listDiscount.currentPage = val
      if (this.multipleSelecdis.length > 0) {
        this.selectcSpuIds = this.multipleSelecdis.map(item => item.id)
      }
      this.getDiscountList()
    },
    // 搜索
    getSearcs () {
      this.getDiscountList()
      this.listDiscount.currentPage = 1
      this.isFilter = true
    },
    // 重置
    getReses () {
      this.listDiscount.keyword = ''
      this.listDiscount.currentPage = 1
      this.getDiscountList()
      this.isFilter = false
    },
    // 优惠券列表
    getDiscountList () {
      let that = this
      that.listLoading = true
      that.listDis = []
      getArrList(that.listDiscount).then(res => {
        that.listDis = res.records
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection()
          that.listDis.forEach(item => {
            if (this.selectcSpuIds.includes(item.id)) {
              this.$refs.multipleTable.toggleRowSelection(item, true)
            }
          })
        })
        that.totalDis = parseInt(res.total)
        that.listLoading = false
      })
    },
    // 行数据的 Key，用来优化 Table 的渲染
    getRowKeys (row) {
      return row.id
    },
    selectHandle (selection) {
      this.multipleSelecdis = selection
      if (this.limit == 1 && selection.length > 1) {
        let delRow = selection.shift()
        this.$refs.multipleTable.toggleRowSelection(delRow, false)
        this.multipleSelecdis = selection
      }
    },
    // Dialog打开的回调
    getDiscountD () {
      this.multipleSelecdis = this.couponList
      if (this.multipleSelecdis.length > 0) {
        this.selectcSpuIds = this.multipleSelecdis.map(item => item.id)
      }
    },
    selectAllHandle (selection) {
      this.multipleSelecdis = selection
    },
    // 确定
    getDatdis () {
      this.comSelectSList = this.multipleSelecdis
      this.dialogDiscounta = false
      this.listDiscount.currentPage = 1
      this.selectcSpuIds = []
      this.$emit('on-coupon', this.multipleSelecdis)
      this.multipleSelecdis = []
    },
    // 取消
    getRedis () {
      this.dialogDiscounta = false
      this.listDiscount.currentPage = 1
      this.selectcSpuIds = []
      this.multipleSelecdis = []
      this.$refs.multipleTable.clearSelection()
    }
  }
}
</script>
